import { Box, CircularProgress, Typography } from "@mui/material";
export default function Loading() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        background: "transparent",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
      }}
    >
      <Box
        component={"div"}
        width={"40px"}
        height={"40px"}
        color={"buttons.primary"}
      >
        {/* <CircularProgress color={"info"} /> */}
        <CircularProgress color={"info"} size={40} />
      </Box>
    </Box>
  );
}
